import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import './YouthSummitSubPages.css';
import heroImg from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/SheLead Circle.jpg';
import img2 from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/REMS0044.jpg';

const tracks = [
  {
    title: 'Employability Track',
    desc: 'For delegates pursuing careers — career development sessions, employer connections, portfolio building, and professional skills development.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
      </svg>
    ),
  },
  {
    title: 'Entrepreneurship Track',
    desc: 'For delegates building businesses — business mentorship, investor introductions, startup toolkits, and access to networks and resources.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>
      </svg>
    ),
  },
  {
    title: 'Leadership Track',
    desc: 'For delegates pursuing leadership and impact — leadership skill building, community project development, and network development across sectors.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
      </svg>
    ),
  },
  {
    title: 'Innovation Track',
    desc: 'For delegates focused on innovation and technology — project development, AI tools, tech mentorship, and connections to innovation ecosystems.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="2" x2="12" y2="6"/><line x1="12" y1="18" x2="12" y2="22"/><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"/><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"/><line x1="2" y1="12" x2="6" y2="12"/><line x1="18" y1="12" x2="22" y2="12"/><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"/><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"/>
      </svg>
    ),
  },
];

const SummitFellowship = () => (
  <div className="sub-page">
    <SEO
      title="YOCILAB Fellowship — YOCILAB Youth Summit 2026"
      description="A 6-month post-Summit program for 20 outstanding delegates — mentorship, leadership development, and continued opportunity access."
    />

    {/* HERO */}
    <section className="sub-hero sub-hero--summit">
      <div className="sub-hero__bg">
        <img src={heroImg} alt="YOCILAB Fellowship" className="sub-hero__img" />
        <div className="sub-hero__overlay" />
      </div>
      <div className="container">
        <div className="sub-hero__content">
          <Link to="/youth-summit" className="sub-hero__back">← Back to Summit</Link>
          <span className="sub-hero__tag">POST-SUMMIT PROGRAM</span>
          <h1 className="sub-hero__title">YOCILAB Fellowship</h1>
          <p className="sub-hero__desc">
            A 6-month post-Summit fellowship for 20 outstanding delegates — mentorship, leadership development, and opportunity.
          </p>
          <div className="sub-hero__meta-chips">
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              November 2026 – April 2027
            </span>
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/></svg>
              20 Fellows Selected
            </span>
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              Virtual + In-person
            </span>
          </div>
        </div>
      </div>
    </section>

    {/* ABOUT */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-two-col">
          <div className="sub-text">
            <span className="section-label">ABOUT THE FELLOWSHIP</span>
            <h2 className="sub-section__title">The Summit is just the beginning.</h2>
            <p className="sub-body">
              At the end of the Summit, we announce 20 outstanding delegates who will continue their journey as YOCILAB Fellows for the next 6 months.
            </p>
            <p className="sub-body">
              Selected based on leadership potential, community impact, business ideas, and performance during the Summit — YOCILAB Fellows get continued access to mentorship, learning, opportunities, and a network that can change the course of their lives.
            </p>
            <p className="sub-body">
              The Fellowship is designed to bridge the gap between the inspiration of the Summit and the realities of the journey ahead — helping Fellows turn momentum into meaningful progress.
            </p>
          </div>
          <div className="sub-visual">
            <img src={img2} alt="Fellowship cohort" className="sub-img" loading="lazy" />
          </div>
        </div>
      </div>
    </section>

    {/* TRACKS */}
    <section className="sub-section sub-section--light">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">FELLOWSHIP TRACKS</span>
          <h2 className="sub-section__title">Your path, your track</h2>
          <p className="sub-section__desc">Fellows choose a track that aligns with their goals and spend 6 months deepening their capabilities in that direction.</p>
        </div>
        <div className="sub-grid-4">
          {tracks.map((t) => (
            <div key={t.title} className="sub-feature-card">
              <div className="sub-feature-card__icon">{t.icon}</div>
              <h3 className="sub-feature-card__title">{t.title}</h3>
              <p className="sub-feature-card__desc">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* WHAT FELLOWS GET */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">FELLOWSHIP BENEFITS</span>
          <h2 className="sub-section__title">What Fellows receive</h2>
        </div>
        <div className="sub-benefits-grid">
          {[
            'Monthly virtual mentorship sessions with industry leaders',
            'Access to ABETA platform and YOCILAB Academy learning resources',
            'Peer learning circles with other Fellows',
            'Guest speaker sessions and master classes',
            'Business or career development support',
            'Introductions to employers, investors, and partners',
            'Community project or business milestone support',
            'YOCILAB Fellow certification and recognition',
          ].map((b, i) => (
            <div key={i} className="sub-benefit-item">
              <span className="sub-benefit-item__check">✓</span>
              <span>{b}</span>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* SELECTION */}
    <section className="sub-section sub-section--summit-dark">
      <div className="container">
        <div className="sub-selection">
          <div className="sub-selection__content">
            <span className="section-label section-label--white">HOW TO BECOME A FELLOW</span>
            <h2 className="sub-selection__title">Selection & Criteria</h2>
            <p className="sub-selection__body">
              You do not apply separately for the Fellowship. All Summit delegates are automatically considered for selection based on their participation and performance during the Summit. The 20 Fellows are announced at the Summit Closing Ceremony.
            </p>
            <p className="sub-selection__body">
              Selection criteria include: leadership potential, community impact, clarity of goals, performance in workshops and challenges, and willingness to commit to the 6-month program.
            </p>
            <Link to="/youth-summit/register" className="sub-btn sub-btn--accent">
              Register for the Summit First
            </Link>
          </div>
        </div>
      </div>
    </section>

    {/* NAV STRIP */}
    <section className="sub-nav-strip summit-nav-strip">
      <div className="container">
        <div className="sub-nav-strip__grid">
          <Link to="/youth-summit/innovation-challenge" className="sub-nav-card">
            <span className="sub-nav-card__label">Before</span>
            <span className="sub-nav-card__title">← Innovation Challenge</span>
          </Link>
          <Link to="/youth-summit" className="sub-nav-card">
            <span className="sub-nav-card__label">Overview</span>
            <span className="sub-nav-card__title">← Full Summit Overview</span>
          </Link>
          <Link to="/youth-summit/register" className="sub-nav-card sub-nav-card--cta">
            <span className="sub-nav-card__label">Get Your Place</span>
            <span className="sub-nav-card__title">Register for Summit →</span>
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default SummitFellowship;
